import { Link } from 'react-router-dom';
import { FaHome, FaArrowLeft, FaSearch } from 'react-icons/fa';
import SEO from '../components/SEO.jsx';

const NotFound = () => {
  return (
    <>
      <SEO 
        title="404 - Page Not Found"
        description="The page you're looking for doesn't exist. Return to Sutrasync homepage."
        url="https://sutrasync.com/404"
      />

      <div className="font-rajdhani min-h-screen bg-[#338edc] text-white flex items-center justify-center relative overflow-hidden">
        {/* Background Effects */}
        <div className="absolute inset-0 bg-[#0a0a0a]">
          <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-gray-900 to-transparent opacity-50"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-gray-800 rounded-full blur-3xl opacity-10"></div>
        </div>

        <div className="container-custom relative z-10 text-center px-4 py-20">
          {/* 404 Number */}
          <div className="mb-8">
            <h1 className="text-[150px] sm:text-[200px] lg:text-[250px] font-bold leading-none text-white opacity-10 select-none">
              404
            </h1>
            <div className="-mt-32 sm:-mt-40 lg:-mt-48">
              <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4">
                Page Not Found
              </h2>
              <p className="text-lg sm:text-xl text-gray-300 font-opensans max-w-2xl mx-auto mb-8">
                Oops! The page you're looking for seems to have wandered off into the digital void. 
                Let's get you back on track.
              </p>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <Link 
              to="/" 
              className="inline-flex items-center bg-white text-[#338edc] font-bold py-4 px-8 rounded-lg hover:bg-gray-100 transition-all duration-300 group hover:shadow-2xl hover:-translate-y-1"
            >
              <FaHome className="mr-3" />
              Go to Homepage
              <FaArrowLeft className="ml-3 rotate-180 group-hover:translate-x-1 transition-transform duration-300" />
            </Link>

            <Link 
              to="/contact" 
              className="inline-flex items-center bg-white/10 backdrop-blur-md border border-white/20 text-white font-bold py-4 px-8 rounded-lg hover:bg-white/15 hover:border-white/40 transition-all duration-300 group"
            >
              <FaSearch className="mr-3" />
              Contact Support
            </Link>
          </div>

          {/* Quick Links */}
          <div className="max-w-2xl mx-auto">
            <p className="text-gray-400 font-opensans mb-4">Or explore these pages:</p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <Link to="/services" className="text-gray-300 hover:text-white transition-colors duration-300 font-opensans">
                Services
              </Link>
              <span className="text-gray-600">•</span>
              <Link to="/about" className="text-gray-300 hover:text-white transition-colors duration-300 font-opensans">
                About Us
              </Link>
              <span className="text-gray-600">•</span>
              <Link to="/blog" className="text-gray-300 hover:text-white transition-colors duration-300 font-opensans">
                Blog
              </Link>
              <span className="text-gray-600">•</span>
              <Link to="/contact" className="text-gray-300 hover:text-white transition-colors duration-300 font-opensans">
                Contact
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
